<div class="main-content">
  <div class="container gray">
    <div class="title-bar">
      <div class="title">
        {{ title }}
      </div>
    </div>
    <div class="content">
        <ng-content></ng-content>
    </div>
  </div>
</div>